<script>
  // Master/detail split for entity show pages: a main `body` column plus a `panels`
  // sidebar (a stack of DetailPanel cards). Collapses to a single column on mobile.
  //
  //   <DetailLayout>
  //     {#snippet body()}…main sections…{/snippet}
  //     {#snippet panels()}
  //       <DetailPanel title="Details">…PropertyRows…</DetailPanel>
  //       <DetailPanel title="Moments" viewAllHref={`/moments?user=${user.id}`}>
  //         <EntityList entity="moment" rows={user.recent_moments} density="compact" />
  //       </DetailPanel>
  //     {/snippet}
  //   </DetailLayout>
  let { body, panels } = $props()
</script>

<div class="grid grid-cols-1 lg:grid-cols-[1fr_20rem] gap-6 items-start">
  <div class="min-w-0 space-y-6">{@render body()}</div>
  {#if panels}
    <aside class="space-y-4 lg:sticky lg:top-6">{@render panels()}</aside>
  {/if}
</div>
